<div class="custom-reg-beackdrop" *ngIf="regProgress">
  <div class="svg-loader"></div>
</div>
<form (ngSubmit)="onSubmit()" #f="ngForm">
  <div class="progressRibbon">
    <button type="button" class="close cancelBtn" typeof="button" aria-label="Close" mat-dialog-close>
      Close
    </button>
    <div class="mod-stepper-container">
      <div class="mod-stepper">
        <div class="stepper-cricle"
             [ngClass]="{ 'active-stepper': selectedStep === 0}">
          <div class="stepper-header">Select Custom Function</div>
          <div class="stepper-number">1</div>
        </div>
        <div class="stepper-bar"></div>
        <div class="stepper-cricle"
             [ngClass]="{ 'active-stepper': selectedStep === 1}">
          <div class="stepper-header">
            Configure Parameters
          </div>
          <div class="stepper-number">2</div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
  <ng-container>
    <mat-horizontal-stepper (selectionChange)="stepChange($event)" labelPosition="bottom" (animationDone)="selectionChange(stepper.selectedIndex )" #stepper>
      <mat-step label="Select Custom Function">
        <ng-template matStepLabel>Select Custom Function</ng-template>
        <div class="float-right text-right mr-5 d-flex">
          <button class="btn font-weight-bold nextBtn"  [disabled]="validateFirstStep()" (click)="setInputParameters(true)" matStepperNext type="button">
            <mat-icon class="mat-icon-arrow">keyboard_arrow_right</mat-icon>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="step1Template"></ng-container>
      </mat-step>
      <mat-step label="configuration">
        <ng-template matStepLabel>Configure Parameters</ng-template>
        <div class="float-right text-right d-flex">
          <div>
            <button class="btn font-weight-bold prevBtn" matStepperPrevious>
              <mat-icon class="mat-icon-arrow">keyboard_arrow_left</mat-icon>
            </button>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="step2Template"></ng-container>
        <div class="stepperFooter">
          <button type="button" [disabled] ="disableSave() || invalidParameter || !f.valid" class="saveBtn2 pull-right" typeof="button" aria-label="Save" 
          (click)="onSubmit()" [ngClass]="{ 'd-none': data.actionType === 'viewFunction'}">
            Save
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>

  </ng-container>
  <ng-template #step1Template>
      <div class="stepTwo">
        <div class="customRegistrationPage">
          <div class="availCustomContainer">
            <div class="registrationFormGroup">
              <div class="form-group row mt-3 mx-3">
                <label for="functionName" class="col-sm-2 col-form-label">Name<span class="text-danger star-danger">*</span></label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="functionName" name="functionName" maxlength="60" 
                  [(ngModel)]="functionName" [ngClass]="{ 'readOnly': data.actionType === 'viewFunction' || data.actionType === 'editFunction'}" (focusout)="validateName($event)" #fName="ngModel" required autocomplete="off" />
                  <div *ngIf="fName.invalid && (fName.dirty || fName.touched)" class="text-danger mt-1">
                    <div *ngIf="fName.errors?.['required']">Function Name is required.</div>
                  </div>
                  <div *ngIf="nameDuplicate" class="text-danger mt-1">Same Function name already exists.</div>
                  <div *ngIf="!nameValid" class="text-danger mt-1">Space and Special Characters are not allowed.</div>
                </div>

                <label for="functionMethod" class="col-sm-2 col-form-label mandatory-field">Method<span class="text-danger star-danger">*</span></label>
                <div class="col-4">
                  <select id="functionMethod" name="functionMethod" class="form-control select-btn" required (change)="validateBeforeUpdate($event)"
                  [(ngModel)]="functionMethod" #fMethod="ngModel" [ngClass]="{ 'readOnly': data.actionType === 'viewFunction'}">
                    <option [ngValue]="null" selected disabled>Select a Method</option>
                    <option *ngFor="let element of methodList" [ngValue]="element">{{element}}</option>
                  </select>
                  <div *ngIf="fMethod.invalid && (fMethod.dirty || fMethod.touched)" class="text-danger mt-1">
                    <div *ngIf="fMethod.errors?.['required']">Method is required.</div>
                  </div>
                </div>

              </div>
              
              <div class="form-group row mt-3 mx-3">                

                <label for="functionUrl" class="col-sm-2 col-form-label mandatory-field">API URL<span class="text-danger star-danger">*</span></label>
                <div class="col-4">
                  <div [matTooltip]="getURLTooltip()" [matTooltipDisabled]="isUrlReadOnly" [matTooltipClass]="url-custom-tooltip">
                    <input type="text" class="form-control largeText urlInput" id="functionUrl" name="functionUrl" (keyup)="validateBeforeUpdate($event)"
                      [(ngModel)]="functionUrl" [pattern]="urlPattern" #fUrl="ngModel" required [disabled]="!isUrlReadOnly" />
                  </div>
                  <div *ngIf="fUrl.invalid && (fUrl.dirty || fUrl.touched)" class="text-danger mt-1">
                    <div *ngIf="fUrl.errors?.['required']">URL is required.</div>
                    <div *ngIf="fUrl.invalid">URL should be a https URL.</div>
                  </div>
                </div>

                <label for="modelImage" class="col-sm-2 col-form-label">Component Image</label>
                <div class="col-4">
                  <div>
                    <input hidden id="modelImage" type="file" [multiple]="false" #imageUploader
                      (change)="handleModelImageInput($event.target.files[0])" accept=".svg" [ngClass]="{ 'readOnly': data.actionType === 'viewFunction'}" />
                  </div>
                  <div class="input-group-text inputCustomised">
                    <span *ngIf="!selectedImageName"> No File Selected</span>
                    <span *ngIf="selectedImageName"> {{selectedImageName}}</span>
                    <div (click)="imageUploader.click()" class="uploadModelFile pointer" [ngClass]="{ 'd-none': data.actionType === 'viewFunction'}">
                      <img src="../../../assets/Images/upload_new.svg" alt="uploadIcon" />
                    </div>
                  </div>
                </div>

              </div>
              
              <div class="form-group row mt-3 mx-3">
                
                <label for="functionDescription" class="col-sm-2 col-form-label">Description<span class="text-danger star-danger">*</span></label>
                <div class="col-4">
                  <textarea class="form-control" id="functionDescription" [(ngModel)]="functionDescription" (keyup)="validateBeforeUpdate($event)"
                  name="functionDescription" maxlength="100" [ngClass]="{ 'readOnly': data.actionType === 'viewFunction'}" required #fDescription="ngModel"></textarea>
                    <div *ngIf="fDescription.invalid && (fDescription.dirty || fDescription.touched)" class="text-danger mt-1">
                      <div *ngIf="fDescription.errors?.['required']">Description is required.</div>
                    </div>
                </div>                

                <label for="authRequired" class="col-2 mt-2 mandatory-field header heading2">
                  OAuth Authentication
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <select class="form-control select-btn" name="authRequired" id="authRequired" (change)="onOauthSelected($event)"
                    [(ngModel)]="authRequired" required [ngClass]="{ 'readonly': data.actionType === 'viewFunction'}">
                    <option [ngValue]="null" selected disabled>Select Oauth Authentication</option>
                    <option *ngFor="let element of oauthAuthenticationList" [ngValue]="element.authId">{{element.type}}</option>
                  </select>
                </div>

              </div>

              <div class="form-group row mt-3 mx-3" *ngIf="isOauthClientAndSecret || isOauthManagedIdentity">
                <label for="subscriptionKey" class="col-2 mt-2 pr-1 mandatory-field header heading2">
                  Subscription Key Name 
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">                   
                  <input type="text" class="form-control largeText" name="subscriptionKey" id="subscriptionKey" [(ngModel)]="subscriptionKey"
                         (change)="secretNameCheck('subscriptionKey',$event)" (keyup)="validateBeforeUpdate($event, subscriptionKey)"
                         maxlength="50" required autocomplete="off"
                         [ngClass]="{ 'readonly': data.actionType === 'viewFunction'}" />
                  <div class="invalid-entry" *ngIf="isSubscriptionAvailable">
                    Subscription Key is alredy in use.
                  </div>
                </div>
                <label for="subscriptionValue" class="col-2 mt-2 pr-1 mandatory-field header heading2">
                  Subscription Key Value
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" name="subscriptionValue" id="subscriptionValue" [(ngModel)]="subscriptionValue"
                         (keyup)="validateBeforeUpdate($event, subscriptionValue)" [ngClass]="{ 'readonly': data.actionType === 'viewFunction'}"
                         maxlength="50" required autocomplete="off" />
                </div>
              </div>
              <div class="form-group row mt-3 mx-3" *ngIf="isOauthClientAndSecret">

                <label for="clientIdName" class="col-2 mt-2 mandatory-field header heading2">
                  Client Id Name
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" name="clientIdName" id="clientIdName" [(ngModel)]="clientIdName"
                         (change)="secretNameCheck('clientKey',$event)" (keyup)="validateBeforeUpdate($event,  clientIdName)"
                         maxlength="50" required autocomplete="off" 
                         [ngClass]="{ 'readonly': data.actionType === 'viewFunction'}" />
                  <div class="invalid-entry" *ngIf="isClientAvailable">
                    Client Id is alredy in use.
                  </div>
                </div>
                <label for="clientIdNameValue" class="col-2 mt-2 mandatory-field header heading2">
                  Client Id Value
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" name="clientIdNameValue" id="clientIdNameValue" [(ngModel)]="clientIdNameValue"
                         (keyup)="validateBeforeUpdate($event, clientIdNameValue)" [ngClass]="{ 'readonly': data.actionType === 'viewFunction'}"
                         maxlength="50" required autocomplete="off" />
                </div>
              </div>

              <div class="form-group row mt-3 mx-3" *ngIf="isOauthClientAndSecret">

                <label for="secretName" class="col-2 mt-2 mandatory-field header heading2">
                  Secret Name
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" name="secretName" id="secretName" [(ngModel)]="secretName"
                         (change)="keyUniqueCheck('secretKey',$event)" (keyup)="validateBeforeUpdate($event, secretName)"
                         maxlength="50" required autocomplete="off" 
                         [ngClass]="{ 'readonly': data.actionType === 'viewFunction'}" />
                  <div class="invalid-entry" *ngIf="isSecretAvailable">
                    Secret name is alredy in use.
                  </div>
                </div>

                <label for="secretNameValue" class="col-sm-2 mt-2 mandatory-field header heading2">
                  Secret Value
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" name="secretNameValue" id="secretNameValue" [(ngModel)]="secretNameValue"
                         (keyup)="validateBeforeUpdate($event, secretNameValue)" [ngClass]="{ 'readonly': data.actionType === 'viewFunction'}"
                         maxlength="50" required autocomplete="off" />
                </div>
              </div>

              <div class="form-group row mt-3 mx-3" *ngIf="isOauthClientAndSecret || isOauthManagedIdentity">

                <label for="scopeKeyName" class="col-2 mt-2 mandatory-field header heading2">
                  Scope Key Name
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" name="scopeKeyName" id="scopeKeyName" [(ngModel)]="scopeKeyName"
                         (change)="keyUniqueCheck('scopeKeyName',$event)" (keyup)="validateBeforeUpdate($event, scopeKeyName)"
                         maxlength="50" required autocomplete="off" 
                         [ngClass]="{ 'readonly': data.actionType === 'viewFunction'}" />
                  <div class="invalid-entry" *ngIf="isScopeAvailable">
                    Scope Key is alredy in use.
                  </div>
                </div>
                <label for="scopeKeyValue" class="col-2 mt-2 mandatory-field header heading2">
                  Scope Key Value
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" name="scopeKeyValue" id="scopeKeyValue" [(ngModel)]="scopeKeyValue"
                         (keyup)="validateBeforeUpdate($event, scopeKeyValue)" [ngClass]="{ 'readonly': data.actionType === 'viewFunction'}"
                         maxlength="50" required autocomplete="off" />
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
  </ng-template>
  <ng-template #step2Template>
      <div class="stepTwo">
        <div class="customRegistrationPage configureParam" *ngIf="modelData.inputParameters.length > 0 && !regProgress">
          <div class="modelTypeContinaer">
            <div class="modelType" [ngClass]="{ 'activeModel': isInputParameters}" (click)="selectParamType('input', true)">
                Input Parameters
            </div>
            <div class="modelType" [ngClass]="{ 'activeModel': !isInputParameters}" (click)="selectParamType('output', false)">              
                Output Parameters              
            </div>
          </div>
          <div class="paramsContainer">
            <div *ngIf="isInputParameters">
              <mat-table class="custom-param-tbl" [dataSource]="inputParameters" matSort matSortActive="parameterName" matSortDirection="asc" matSortDisableClear>
                <ng-container matColumnDef="parameterName">
                  <mat-header-cell *matHeaderCellDef class="">Name</mat-header-cell>
                  <mat-cell *matCellDef="let element; let rowIndex = index" class="regularText">
                    <input class="form-control" 
                    [ngModelOptions]="{standalone: true}" 
                    [(ngModel)]="modelData.inputParameters[rowIndex].parameterName" 
                    [ngClass]="{ 'readOnly': data.actionType === 'viewFunction'}"
                    (keyup)="validateParameter()">
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="captionName">
                  <mat-header-cell *matHeaderCellDef class="">Display Name</mat-header-cell>
                  <mat-cell *matCellDef="let element; let rowIndex = index" class="regularText">
                    <input class="form-control" 
                    [ngModelOptions]="{standalone: true}" 
                    [(ngModel)]="modelData.inputParameters[rowIndex].captionName"
                    [ngClass]="{ 'readOnly': data.actionType === 'viewFunction'}"
                    (keyup)="validateParameter()">
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="action">
                  <mat-header-cell *matHeaderCellDef class=" matAction"></mat-header-cell>
                  <mat-cell *matCellDef="let element; let i=index" class="regularText matAction">
                    <button class="deleteIcon pointer" (click)="deleteModel(i)" matTooltip="Delete" mat-icon-button 
                    *ngIf=" i<inputParameters.data.length" [ngClass]="{ 'd-none': data.actionType === 'viewFunction'}">
                      <mat-icon class="action-icon-delete action-icon-common"></mat-icon>
                    </button>
                    <button class="deleteIcon pointer" matTooltip="Add" mat-icon-button 
                    *ngIf="displayAddParameters(i)" (click)="addNewParameter()" [ngClass]="{ 'd-none': data.actionType === 'viewFunction'}">
                      <mat-icon class="action-icon-add action-icon-common"></mat-icon>
                    </button>
                  </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" stickybits></mat-header-row>
                <mat-row *matRowDef="let rows; columns: displayedColumns;"></mat-row>
              </mat-table>
              <div *ngIf="inputParamDuplicate" class="text-danger mt-2 mx-3">Input Name is already used.</div>
              <div *ngIf="inputCaptionDuplicate" class="text-danger mt-2 mx-3">Input Display Name is already used.</div>
            </div>
            <div *ngIf="!isInputParameters">
              <mat-table class="custom-param-tbl" [dataSource]="outputParameters" matSort matSortActive="parameterName" matSortDirection="asc" matSortDisableClear>
                <ng-container matColumnDef="parameterName">
                  <mat-header-cell *matHeaderCellDef class="">Name</mat-header-cell>
                  <mat-cell *matCellDef="let element; let rowIndex = index" class="regularText">
                    <input class="form-control" 
                    [ngModelOptions]="{standalone: true}" 
                    [(ngModel)]="modelData.outputParameters[rowIndex].parameterName" 
                    [ngClass]="{ 'readOnly': data.actionType === 'viewFunction'}"
                    (keyup)="validateParameter()">
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="captionName">
                  <mat-header-cell *matHeaderCellDef class="">Display Name</mat-header-cell>
                  <mat-cell *matCellDef="let element; let rowIndex = index" class="regularText">
                    <input class="form-control" 
                    [ngModelOptions]="{standalone: true}" 
                    [(ngModel)]="modelData.outputParameters[rowIndex].captionName"
                    [ngClass]="{ 'readOnly': data.actionType === 'viewFunction'}"
                    (keyup)="validateParameter()">
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="action">
                  <mat-header-cell *matHeaderCellDef class=" matAction"></mat-header-cell>
                  <mat-cell *matCellDef="let element; let i=index" class="regularText matAction">
                    <button class="deleteIcon pointer" (click)="deleteModel(i)" matTooltip="Delete" mat-icon-button 
                    *ngIf=" i<outputParameters.data.length" [ngClass]="{ 'd-none': data.actionType === 'viewFunction'}">
                      <mat-icon class="action-icon-delete action-icon-common"></mat-icon>
                    </button>
                    <button class="deleteIcon pointer" matTooltip="Add" mat-icon-button 
                    *ngIf="displayAddParameters(i)" (click)="addNewParameter()" [ngClass]="{ 'd-none': data.actionType === 'viewFunction'}">
                      <mat-icon class="action-icon-add action-icon-common"></mat-icon>
                    </button>
                  </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" stickybits></mat-header-row>
                <mat-row *matRowDef="let rows; columns: displayedColumns;"></mat-row>
              </mat-table>
              <div *ngIf="outputParamDuplicate" class="text-danger mt-2 mx-3">Output Name is already used.</div>
              <div *ngIf="outputCaptionDuplicate" class="text-danger mt-2 mx-3">Output Display Name is already used.</div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
  </ng-template>

</form>
